/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RdSAPCarbonAmount } from './rdSAPCarbonAmount';
import { EnergyUseSummary } from './energyUseSummary';


/**
 * TBC
 */
export interface RdSAPImprovementBreakdown { 
    carbonSavings?: RdSAPCarbonAmount;
    newRating?: EnergyUseSummary;
    /**
     * The improvement measure name. TBC -- Enum?
     */
    measureType: string;
    /**
     * TBC
     */
    _indicativeCosts?: number;
    /**
     * TBC
     */
    _savings?: number;
}

